export default __webpack_public_path__ + "static/media/3536 spice rack B top.c15637cb.png";